__turbopack_context__.v({
  "pane": "ZXE-Pa_pane",
  "tabs": "ZXE-Pa_tabs",
  "title": "ZXE-Pa_title",
});
